import { Button, styled } from '@arpeggi/ui'

const Root = styled('div', {
  display: 'none',
  '@tablet': {
    display: 'flex'
  },
  alignItems: 'center',
  gap: '8px'
})

const MainAction = styled(Button)

const SecondaryAction = styled(Button)

export const Actions = { Root, MainAction, SecondaryAction }
